import { render, staticRenderFns } from "./eventDataUpdate.vue?vue&type=template&id=ca55989c&"
import script from "./eventDataUpdate.vue?vue&type=script&lang=js&"
export * from "./eventDataUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports